import { ReactComponent as Close } from '../../../../assets/icons/close.svg';

export { Close };
